
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 0C14.738 0 19 4.262 19 9.5S14.738 19 9.5 19 0 14.738 0 9.5 4.262 0 9.5 0zm3.082 7.993a.382.382 0 000-.5.296.296 0 00-.45 0l-3.896 4.333-1.36-1.515a.296.296 0 00-.45 0 .382.382 0 000 .5l1.585 1.762c.06.067.14.104.225.104a.302.302 0 00.225-.104l4.121-4.58z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/validate.svg